<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Services
	import { postReq } from '../../../services/http';
	//Configs
	import { devices_config } from '@devices/index';
	//Design system components
	import { Button, ButtonV2, Checkbox, Select, SelectV2, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';
	import type { Writable } from 'svelte/store';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';
	import { getContext, onDestroy } from 'svelte';
	import SettingGuide from '../SettingGuide.svelte';

	export let device: Device;

	const id = device.id,
		save = async () => {
			waitForResponse = true;
			device.is_master = isMaster;
			device.master_device = selectedMaster === masterDevicesList[0] ? null : selectedMaster;
			const res = await postReq(`/interface/device/save`, {
				id,
				data: JSON.stringify(device),
			});
			let toastTexts = {};
			if (res?.isok) {
				if (intiIsMaster != isMaster) {
					toastTexts = {
						success: isMaster
							? $format('device_is_master_scc_toast', {
									default: 'Device set as Master.',
								})
							: $format('device_is_master_scc_toast', {
									default: 'Device is no longer a Master.',
								}),
					};
					intiIsMaster = isMaster;
					device.is_master = isMaster;
				}

				if (initSelectedMaster !== selectedMaster) {
					toastTexts = {
						success:
							selectedMaster !== masterDevicesList[0]
								? $format('device_is_master_scc_toast', {
										default: `Selected ${$devices[selectedMaster].name} as Master.`,
									})
								: $format('device_is_master_scc_toast', {
										default: 'Removed Master device',
									}),
					};
					initSelectedMaster = selectedMaster;
					device.master_device = selectedMaster;
				}

				devices.update(device);
			}
			onSettingsResponse(res, device, toastTexts);
			waitForResponse = false;
		};

	let waitForResponse = false;

	let isMaster = $devices[id].is_master || false,
		intiIsMaster = isMaster,
		selectedMaster = $devices[id].master_device || null,
		initSelectedMaster = selectedMaster;

	const devicesFilter = (devicesList) => {
		return [
			'none',
			...Object.keys(devicesList).filter((dId) => {
				if (devices_config[$devices[dId].type]?.isPM && $devices[dId].is_master) {
					return dId;
				}
			}),
		];
	};

	$: masterDevicesList = devicesFilter($devices);
	$: isSaveDisabled =
		waitForResponse || (isMaster == intiIsMaster && initSelectedMaster == selectedMaster);
	$: SelectC = $showNewLayout ? SelectV2 : Select;
	$: ButtonC = $showNewLayout ? ButtonV2 : Button;

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: save,
				loading: waitForResponse,
				disabled: isSaveDisabled,
				icon: 'fas fa-save',
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<SettingGuide
	text={$format('settings_guide_consumption_hierarchy', {
		default:
			'Mark this device as a master meter, or pick a master so nested usage is not counted twice.',
	})}
/>

<Checkbox size="m" bind:checked={isMaster} class="mb-s" id="checkbox-gw4mrw5"
	>{$format('is_master_label', { default: 'Is a "Master" device' })}</Checkbox
>

{#if !intiIsMaster}
	<Text class="mb-m" element="h2">
		{$format('label_select_master_device', {
			default: 'Select "Master" device',
		})}
	</Text>

	<svelte:component
		this={SelectC}
		class="width-full mb-m "
		bind:value={selectedMaster}
		options={masterDevicesList}
		icon="fas fa-crown"
		label={masterDevicesList.length === 0
			? $format('label_no_master_devices', {
					default: 'No Master devices',
				})
			: $format('label_select_master', {
					default: 'Select Master',
				})}
		disabled={masterDevicesList.length === 0}
		id="select-rajmoef"
		aria-labelledby="select-rajmoef"
	/>
{/if}

{#if !$showNewLayout}
	<svelte:component
		this={ButtonC}
		size="m"
		width="full"
		class="text-uppercase"
		disabled={isSaveDisabled}
		on:click={save}
		loading={waitForResponse}
		>{$format('button_apply', { default: 'apply' })}
	</svelte:component>
{/if}
